import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useTruncateStyles = makeStyles(() =>
  createStyles({
    root: {
      display: '-webkit-box',
      boxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },

    'line-1': {
      lineClamp: 1
    },

    'line-2': {
      lineClamp: 2
    },

    'line-3': {
      lineClamp: 3
    },

    'line-4': {
      lineClamp: 4
    },

    'line-5': {
      lineClamp: 5
    },

    'line-6': {
      lineClamp: 6
    },

    'line-7': {
      lineClamp: 7
    },

    'line-8': {
      lineClamp: 8
    }
  })
)
